import React, { Component, Fragment } from 'react'
import { Collapse } from 'antd'
import Annual from './Table/Annual'
import Compassionate from './Table/Compassionate'
import Medical from './Table/Medical'
import Hospitalisation from './Table/Hospitalisation'
import Parental from './Table/Parental'
import { numVal } from '../../../../../modules/Utils'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'

const Panel = Collapse.Panel

class Entitlements extends Component {
  render() {
    const {
      updateContract,
      updateContractRollover,
      updateContractMedicalOptions,
      type,
      contract,
    } = this.props

    console.log(contract.annual)
    return (
      <Fragment>
        <Collapse accordion defaultActiveKey={['1']} bordered={false}>
          <Panel header="ANNUAL LEAVE" key="1">
            <Annual
              data={contract.annual}
              rollover={numVal(contract, 'rollover.annual')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="COMPASSIONATE" key="2">
            <Compassionate
              data={contract.compassionate}
              rollover={numVal(contract, 'rollover.compassionate')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="HOSPITALISATION" key="3">
            <Hospitalisation
              data={contract.hospitalisation}
              rollover={numVal(contract, 'rollover.hospitalisation')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="MEDICAL" key="4">
            <Medical
              data={contract.medical}
              rollover={numVal(contract, 'rollover.medical')}
              updateContract={updateContract}
              medicalOptions={contract.medicalOptions}
              updateContractMedicalOptions={updateContractMedicalOptions}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
          <Panel header="PARENTAL" key="5">
            <Parental
              data={contract.parental}
              rollover={numVal(contract, 'rollover.parental')}
              updateContract={updateContract}
              updateContractRollover={updateContractRollover}
              type={type}
            />
          </Panel>
        </Collapse>
      </Fragment>
    )
  }
}

export default compose(withLoadingSection)(Entitlements)
